import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import "./all.scss";
import PropTypes from "prop-types";
import Seo from "./Seo";

const SmoothScroll =
  typeof window !== `undefined` ? require("smooth-scroll") : null;

const TemplateWrapper = (props) => {
  let {
    children,
    transparentNavbar,
    title,
    description,
    schemaMarkup,
    footer,
  } = props;

  const data = useStaticQuery(graphql`
    query Navbar {
      category: allMarkdownRemark(
        filter: { frontmatter: { templateKey: { eq: "category" } } }
      ) {
        edges {
          node {
            fields {
              slug
            }
            frontmatter {
              name
              image {
                childImageSharp {
                  fixed(height: 100) {
                    ...GatsbyImageSharpFixed_withWebp
                  }
                }
              }
            }
          }
        }
      }
    }
  `);
  React.useEffect(() => {
    if (window && SmoothScroll) {
      var scroll = new SmoothScroll("a[data-scroll]");
    }
    // if (window) {
    //   window.dataLayer = window.dataLayer || [];
    //   function gtag() {
    //     window.dataLayer.push(arguments);
    //   }
    //   gtag("js", new Date());
    //
    //   gtag("config", "UA-134257618-1");
    // }
  }, []);

  React.useEffect(() => {
    setTimeout(() => {
      var truepush = window.truepush || [];
      truepush.push(function () {
        truepush.Init(
          {
            id: "5fa109661193e81485015fdb",
          },
          function (error) {
            if (error) console.log(error);
          }
        );
      });
    }, 10000);
  }, []);

  return (
    <div>
      <Seo
        title={title}
        description={description}
        schemaMarkup={schemaMarkup}
      />
      <Navbar transparent={transparentNavbar} navbarCategory={data} />
      <div className={"dark-body-bg"}>
        <div className={"container-fluid"}>{children}</div>
      </div>
      {!footer && <Footer />}
    </div>
  );
};

export default TemplateWrapper;